import React, { useMemo } from 'react';
import * as PropTypes from 'prop-types';
import { useEmailDraft } from '../emailDraftsSlice';
import { IdPropType } from '../../../proptypes/basic';

const MailDraftContactsSlim = ({ draftId, withoutAt, type }) => {
    const [{ emailReceivers }] = useEmailDraft(draftId);

    const receivers = useMemo(() => {
        return emailReceivers
            .filter((r) => r.type === type)
            .map((r) => r.emailAddress)
            .map((a) =>
                a.name !== '' && a.name !== null
                    ? a.name
                    : withoutAt
                    ? a.address.split('@')[0]
                    : a.address
            );
    }, [emailReceivers, withoutAt, type]);

    return <>{receivers.join(', ')}</>;
};

MailDraftContactsSlim.propTypes = {
    draftId: IdPropType.isRequired,
    withoutAt: PropTypes.bool,
    type: PropTypes.string,
};

MailDraftContactsSlim.defaultProps = {
    withoutAt: false,
    type: 'from',
};

export default MailDraftContactsSlim;
